
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Extratos from './pages/Extratos'
import CadastroPortalAdministradoras from './pages/CadastroDeContas'
import Redirect from './pages/redirect'
import ListaExtratos from './pages/ListaExtratos'
import ListaCategoria from './components/Categoria/ListaCategoria/ListaCategoria'
import ConciliacaoVendas from './pages/ConciliacaoVendas/Index'
import ConciliacaoBancaria from './pages/ConciliacaoBancaria/Index'

export default function App() {

  return (
    <BrowserRouter>
      <Switch>
        {/* <Route path='/:id?' exact component={ListaPortalAdministradoras} /> */}
        <Route path='/ConciliacaoVendas' exact component={ConciliacaoVendas} />
        <Route path='/CadastroPortalAdministradoras' exact component={CadastroPortalAdministradoras} />
        <Route path="/ListaContas" exact component={Extratos} />
        <Route path="/ListaExtratos" exact component={ListaExtratos} />
        <Route path="/ListaCategoria" exact component={ListaCategoria} />
        <Route path="/ConciliacaoBancaria" exact component={ConciliacaoBancaria} />
        <Route path="/redirect/:id" exact component={Redirect} />
      </Switch>
    </BrowserRouter>
  )
}